
function formatLineupMoney(cents, section) {
  const activeCurrency =
    window.Shopify?.currency?.active ||
    section?.dataset.shopCurrency ||
    'USD';
  const locale = document.documentElement.lang || navigator.language || 'en-US';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: activeCurrency
  }).format(cents / 100);
}


function updateLineupPriceElement(priceEl, priceFormatted, compareAtFormatted, priceCents, compareAtCents) {
  if (!priceEl) return;

  const valueEl = priceEl.querySelector('[data-lineup-price-value]');
  const compareEl = priceEl.querySelector('[data-lineup-compare-at]');
  const showCompareAt = compareAtCents > priceCents;

  priceEl.classList.toggle('price--on-sale', showCompareAt);

  if (valueEl) {
    valueEl.textContent = priceFormatted;
  }

  if (compareEl) {
    if (showCompareAt) {
      compareEl.textContent = compareAtFormatted;
      compareEl.closest('[hidden]')?.removeAttribute('hidden');
      compareEl.removeAttribute('hidden');
    } else {
      compareEl.textContent = '';
      const compareWrapper = compareEl.closest('span:not([class])') || compareEl.parentElement;
      if (compareWrapper && compareWrapper !== priceEl) {
        compareWrapper.setAttribute('hidden', '');
      }
    }
  }
}

function updateLineupCardPricingFromLiquid(card, quantity) {
  const subscriptionPriceEl = card.querySelector('[data-lineup-price="subscription"]');
  const oneTimePriceEl = card.querySelector('[data-lineup-price="onetime"]');

  const oneTimePrice = card.getAttribute(`data-price-onetime-${quantity}`);
  const oneTimeCompareAt = card.getAttribute(`data-compare-onetime-${quantity}`);
  const oneTimePriceCents = parseInt(card.getAttribute(`data-price-onetime-${quantity}-cents`), 10);
  const oneTimeCompareAtCents = parseInt(card.getAttribute(`data-compare-onetime-${quantity}-cents`), 10);

  const subscriptionPrice = card.getAttribute(`data-price-subscription-${quantity}`);
  const subscriptionCompareAt = card.getAttribute(`data-compare-subscription-${quantity}`);
  const subscriptionPriceCents = parseInt(card.getAttribute(`data-price-subscription-${quantity}-cents`), 10);
  const subscriptionCompareAtCents = parseInt(card.getAttribute(`data-compare-subscription-${quantity}-cents`), 10);

  updateLineupPriceElement(
    oneTimePriceEl,
    oneTimePrice,
    oneTimeCompareAt,
    oneTimePriceCents,
    oneTimeCompareAtCents
  );

  updateLineupPriceElement(
    subscriptionPriceEl,
    subscriptionPrice,
    subscriptionCompareAt,
    subscriptionPriceCents,
    subscriptionCompareAtCents
  );
}

function getUsdToActiveCurrencyRate(section) {
  const activeCurrency =
    window.Shopify?.currency?.active ||
    section?.dataset.shopCurrency ||
    'USD';
  const currencyRates = window.Shopify?.currency?.rates;

  if (currencyRates && currencyRates.USD && currencyRates[activeCurrency]) {
    return currencyRates[activeCurrency] / currencyRates.USD;
  }

  if (activeCurrency === 'USD') return 1;

  return typeof window.Shopify?.currency?.rate === 'number'
    ? window.Shopify.currency.rate
    : 1;
}

function getPerItemDiscountCents(card, quantity, section) {
  if (!card || card.dataset.discountEligible !== 'true') return 0;

  const discountUsdCents =
    quantity >= 3
      ? 200
      : quantity === 2
      ? 100
      : 0;

  if (!discountUsdCents) return 0;

  const usdToActiveRate = getUsdToActiveCurrencyRate(section);
  return Math.round(discountUsdCents * usdToActiveRate);
}

function updateLineupCardPricing(card, quantity, section) {
  if (card.hasAttribute('data-price-onetime-1-cents')) {
    updateLineupCardPricingFromLiquid(card, quantity);
    return;
  }

  const oneTimeUnitPrice = parseInt(card.dataset.unitPrice, 10);
  const subscriptionUnitPrice = parseInt(card.dataset.subscriptionUnitPrice, 10);
  const compareAtUnit = parseInt(card.dataset.compareAtUnit, 10);
  if (!oneTimeUnitPrice) return;

  const subscriptionPriceEl = card.querySelector('[data-lineup-price="subscription"]');
  const oneTimePriceEl = card.querySelector('[data-lineup-price="onetime"]');

  const perItemDiscountCents = getPerItemDiscountCents(card, quantity, section);
  const totalDiscountCents = perItemDiscountCents * quantity;
  const compareAtTotal = compareAtUnit * quantity;

  if (subscriptionPriceEl && subscriptionUnitPrice > 0) {
    const subscriptionTotal = Math.max(subscriptionUnitPrice * quantity - totalDiscountCents, 0);
    const oneTimeTotal = Math.max(oneTimeUnitPrice * quantity - totalDiscountCents, 0);
    updateLineupPriceElement(
      subscriptionPriceEl,
      formatLineupMoney(subscriptionTotal, section),
      formatLineupMoney(oneTimeTotal, section),
      subscriptionTotal,
      oneTimeTotal
    );
  }

  if (oneTimePriceEl) {
    const oneTimeTotal = Math.max(oneTimeUnitPrice * quantity - totalDiscountCents, 0);
    updateLineupPriceElement(
      oneTimePriceEl,
      formatLineupMoney(oneTimeTotal, section),
      formatLineupMoney(compareAtTotal, section),
      oneTimeTotal,
      compareAtTotal
    );
  }
}

document.addEventListener('DOMContentLoaded', function(){
  if (typeof Swiper !== 'undefined') {
    document.querySelectorAll('.collection-lineup-slider').forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesOffsetAfter: 20,
        breakpoints: {
          0: {
            slidesPerView: 1.43
          },
          750: {
            slidesPerView: 2.5
          },
          1200: {
            slidesPerView: 4
          }
        },
        scrollbar: {
            el: slider.querySelector('.swiper-scrollbar'),
            draggable: true
        },
      });
    });
  }

  const pricingRoots = document.querySelectorAll('[data-lineup-pricing-root], .collection-lineup');

  if (pricingRoots.length === 0) {
    const standaloneCards = document.querySelectorAll('.lineup-card');
    standaloneCards.forEach((card) => {
      let quantity = 1;
      const qtyButtons = card.querySelectorAll('.qty-btn');
      qtyButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          qtyButtons.forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          quantity = parseInt(btn.dataset.qty, 10);
          card.dataset.quantity = quantity;
          updateLineupCardPricing(card, quantity, null);
        });
      });
      card.dataset.quantity = 1;
      updateLineupCardPricing(card, 1, null);
    });
  }

  pricingRoots.forEach((section) => {
    section.querySelectorAll('.lineup-card').forEach((card) => {
      let quantity = 1;
      const qtyButtons = card.querySelectorAll('.qty-btn');
      qtyButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          qtyButtons.forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          quantity = parseInt(btn.dataset.qty, 10);
          card.dataset.quantity = quantity;
          updateLineupCardPricing(card, quantity, section);
        });
      });
      card.dataset.quantity = 1;
      updateLineupCardPricing(card, 1, section);
    });
  });

  document.querySelectorAll('.product-variant-select').forEach((select) => {
    select.addEventListener('change', function(){
      const card = this.closest('.lineup-card');
      const button = card.querySelector('.lineup-add-btn');
      button.dataset.variantId = this.value;
    });
  });
  document.querySelectorAll('.lineup-add-btn').forEach((button) => {
    button.addEventListener('click', async function(){
      const card = this.closest('.lineup-card');
      const variantId = this.dataset.variantId;
      const quantity = parseInt(card.dataset.quantity || 1);
      const selectedPurchase = card.querySelector(
        'input[type="radio"]:checked'
      ).value;
      let sellingPlan = null;
      if (selectedPurchase === 'subscription') {
        sellingPlan = card.querySelector('.lineup-frequency').value;
      }

    //   const purchaseType = card.querySelector(
    //     'input[type="radio"]:checked'
    //   ).value;
    //   const frequency = card.querySelector('.lineup-frequency')?.value;
    //   let properties = {};
    //   if (purchaseType === 'subscription') {
    //     properties = {
    //       shipping_interval_frequency: frequency,
    //       shipping_interval_unit_type: 'days'
    //     };
    //   }
      this.classList.add('loading');
      this.innerHTML = 'ADDING...';
      try {
        const item = {
          id: variantId,
          quantity: quantity
        };
        if (sellingPlan) {
          item.selling_plan = sellingPlan;
        }
        console.log(item);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            // items: [
            //   {
            //     id: variantId,
            //     quantity: quantity,
            //     // properties: properties
            //   }
            // ]
            items: [item]
          })
        });
        const data = await response.json();
        console.log(data);
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderContents(data);
        } else {
          window.location.href = '/cart';
        }
        this.innerHTML = 'ADDED';
      } catch(error){
        console.error(error);
        this.innerHTML = 'ERROR';
      }
      setTimeout(() => {
        this.classList.remove('loading');
        this.innerHTML = 'ADD TO CART';
      }, 2000);
    });
  });

  document.querySelectorAll('.purchase-option').forEach((option) => {
    option.addEventListener('click', function () {
      const wrapper = this.closest('.purchase-type-wrapper');
      if (!wrapper) return;

      wrapper.querySelectorAll('.purchase-option').forEach((el) => {
        el.classList.remove('active');
      });

      this.classList.add('active');

      const input = this.querySelector('input');
      if (input) input.checked = true;
    });
  });
});